import React from "react";
import { IMAGES } from "../lib/site";
import { Reveal } from "../components/Reveal";
import { PageHero, SectionHeader, CTAButton, useSeo } from "../components/Shared";

const STEPS = [
  { n: "01", t: "Plan and Schedule", d: "We help map timelines, deliverables, and a multi-event calendar so nothing slips." },
  { n: "02", t: "Prepare Assets", d: "Exhibits, apparel, collateral, and giveaways are inspected, kitted, and staged." },
  { n: "03", t: "Coordinate Shipping & Show Services", d: "Shipment scheduling, event forms, labor, and drayage support handled for you." },
  { n: "04", t: "Support Installation and the Event", d: "Setup, onsite coordination, and problem-solving while your team focuses on attendees." },
  { n: "05", t: "Dismantle, Return, Inspect & Update", d: "Teardown, return logistics, inspection, and inventory updates after the event." },
  { n: "06", t: "Standardize Repeat Programs", d: "Repeatable playbooks across multiple events for consistent, predictable execution." },
];

export default function EventManagement() {
  useSeo(
    "Event & Project Management | MJG Promotions",
    "Event logistics and exhibit management from planning through teardown — shipment scheduling, show services, installation, and onsite support by MJG Promotions."
  );
  return (
    <>
      <PageHero
        eyebrow="Event & Project Management"
        title="Event Support From Planning Through Teardown"
        intro="MJG acts as an extension of your team — managing exhibit logistics, shipment scheduling, show services, labor, drayage, forms, installation, dismantling, onsite needs, and multi-event calendars."
        image={IMAGES.eventStage}
      />

      <section className="bg-white py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5">
          <SectionHeader eyebrow="An Extension of Your Team" title="We Handle the Details Behind Every Event" />
          <div className="mt-12 grid gap-px overflow-hidden border border-brand-line bg-brand-line md:grid-cols-2 lg:grid-cols-3">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={(i % 3) * 0.06}>
                <div className="group h-full bg-brand-warm p-8 transition-colors hover:bg-brand-black">
                  <span className="font-mono text-sm font-semibold text-brand-red">{s.n}</span>
                  <h3 className="mt-6 text-lg font-bold text-brand-black transition-colors group-hover:text-white">{s.t}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-brand-gray transition-colors group-hover:text-white/70">{s.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-brand-warm py-20 sm:py-28">
        <div className="mx-auto max-w-7xl px-5">
          <div className="grid items-center gap-12 lg:grid-cols-2">
            <Reveal><img src={IMAGES.conference} alt="Corporate event audience during a conference session" className="w-full rounded-sm object-cover" loading="lazy" /></Reveal>
            <Reveal delay={0.1}>
              <SectionHeader eyebrow="Talk to Us" title="Plan Your Next Event With MJG" body="From a single activation to a full season of shows, we help you standardize and execute — so your brand shows up ready every time." />
              <CTAButton to="/contact" testId="event-cta" variant="primary">Talk to an Event Specialist</CTAButton>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
